// extracted by mini-css-extract-plugin
export default {"BaseP":"BaseP_BaseP__kUzAh"};